import React from 'react'
import { RivenditoreCardContent } from '@components/molecules'
import styles from './RivenditoreCard.module.sass'

interface Props {
  rivenditore?: any
  size?: 'sm' | 'md'
  className?: string
}

const RivenditoreCard = (props: Props) => {
  const { rivenditore = undefined, size = 'md', className = '' } = props

  return rivenditore ? (
    <RivenditoreCardContent
      rivenditore={rivenditore}
      size={size}
      className={`${styles.root} ${className}`}
    />
  ) : (
    <></>
  )
}

export default RivenditoreCard
